import * as Actions from '../actions';

const initialState = {
	data:
	[
		[
			{
				"_id": "0",
				"cluster_id": "0",
				"cpus": 0,
				"loadAvg": 0,
				"time": "0"
			},
		],
	],
};

const cpuAvgReducer = (state = initialState, action) => {

	switch (action.type) {
		// SET
		case Actions.SET_CPUAVG: {
			return action.payload;
		}
		// DEFAULT
		default: {
			return state;
		}
	}
};

export default cpuAvgReducer;
